import { TFunction } from 'i18next';
import { StringValue_Translation } from './stringValue_Translation';
import { PrivacyFramework } from 'models/processingActivity';

export enum StringValueTypes {
  Classification = 1,
  KPIChoice = 2,
  DataSubject = 3,
  DataCategory = 4,
  LegalBasis = 5,
  ExecutingEntity = 6,
  RetentionPeriod = 7,
  Location = 8,
  RecipientCategory = 9,
  DataSubjectScale = 10,
}

export enum DataZoneKey {
  None = 0,
  TenantZone = 1,
  Adequate = 2,
  Other = 3,
}

let newStringValueId = -1;

export default class StringValue {
  stringValueId: number;

  stringValueKey?: number;

  stringTypeId: number;

  stringTypeEntityId?: number;

  sortOrder?: number;

  trans: StringValue_Translation[];

  transIdx: number;

  // Flattened Trans properties
  value: string;

  description?: string;

  constructor() {
    this.stringValueId = newStringValueId;
    this.stringTypeId = 0;
    this.trans = [];
    this.value = '';
    this.transIdx = -1;
    newStringValueId--;
  }

  isEqual(test: StringValue): boolean {
    if (test.stringTypeId !== this.stringTypeId) return false;
    if (test.stringValueKey !== this.stringValueKey) return false;
    if (test.stringTypeEntityId !== this.stringTypeEntityId) return false;
    if (test.sortOrder !== this.sortOrder) return false;
    if (test.description !== this.description) return false;
    if (test.value !== this.value) return false;

    return true;
  }

  clone(): StringValue {
    const output = new StringValue();
    output.stringValueKey = this.stringValueKey;
    output.stringValueId = this.stringValueId;
    output.stringTypeId = this.stringTypeId;
    output.stringTypeEntityId = this.stringTypeEntityId;
    output.sortOrder = this.sortOrder;
    output.value = this.value;
    output.description = this.description;
    output.transIdx = this.transIdx;
    output.trans = [...this.trans];

    return output;
  }

  static getTypeText(type: StringValueTypes, lowerCase: boolean, t: TFunction<string[]>): string {
    let result: string = '';
    switch (type) {
      case StringValueTypes.DataSubject:
        result = t('stringValue:Type.DataSubject');
        break;
      case StringValueTypes.DataCategory:
        result = t('stringValue:Type.DataCategory');
        break;
      case StringValueTypes.ExecutingEntity:
        result = t('stringValue:Type.ExecutingEntity');
        break;
      case StringValueTypes.LegalBasis:
        result = t('stringValue:Type.LegalBasis');
        break;
      case StringValueTypes.RetentionPeriod:
        result = t('stringValue:Type.RetentionPeriod');
        break;
      case StringValueTypes.Location:
        result = t('stringValue:Type.Location');
        break;
      case StringValueTypes.RecipientCategory:
        result = t('stringValue:Type.RecipientCategory');
        break;
      case StringValueTypes.DataSubjectScale:
        result = t('stringValue:Type.DataSubjectScale');
        break;
      default:
        result = '';
    }

    return lowerCase ? result.toLowerCase() : result;
  }

  static getDataZoneText(t: TFunction<string[]>, stringValueKey: DataZoneKey, privacyFramework: PrivacyFramework): string {
    switch (stringValueKey) {
      case DataZoneKey.TenantZone:
        return privacyFramework === PrivacyFramework.SwissDSG ? t('stringValue:DataZones.Switzerland') : t('stringValue:DataZones.EEA');
      case DataZoneKey.Adequate:
        return privacyFramework === PrivacyFramework.SwissDSG ? t('stringValue:DataZones.DSGAdequate') : t('stringValue:DataZones.EUAdequate');
      case DataZoneKey.Other:
        return t('stringValue:DataZones.Other');
      default:
        return t('stringValue:DataZones.None');
    }
  }
}
